import React, { Component, PropTypes } from 'react'

import Pagination from 'components/Common/Pagination'
import PracticeList from 'components/QuestionList/PracticeList'
import HotCourse from 'components/QuestionList/HotCourse'

import { getQuestions, getRecommands } from 'common/api'
import config from 'config'
import styles from './index.css'


class QuestionListContainer extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        examinationId: PropTypes.string.isRequired,
        questionTypeId: PropTypes.string.isRequired,
        subjectId: PropTypes.string.isRequired,
        tagId: PropTypes.string.isRequired
      })
    })
  }

  constructor () {
    super()
    this.state = {
      tagName: 'Social Science',
      detail: 'hello, world',
      practiceList: [],
      totalPage: 1,
      current: 1,
      recomendsInfo: [],
      examInfo: config.examInfo[0]
    }
    this.handlePageChange = this.handlePageChange.bind(this)
  }

  componentDidMount () {
    const { location: { search, query }, params: { exam } } = this.props
    this.setState({ current: Number(query.page) })
    Promise
      .all([getQuestions(search), getRecommands(exam)])
      .then(([questions, exams]) => {
        this.setState({
          tagName: questions.tagName,
          practiceList: questions.practiceList,
          totalPage: questions.totalPage,
          recomendsInfo: exams,
          examInfo: config.examInfo.find(item => item.subject === exam)
        })
      })
  }

  componentWillReceiveProps (nextProps) {
    const { location : { search } } = nextProps
    getQuestions(search).then(questions => {
      this.setState({
        practiceList: questions.practiceList
      })
    })
  }

  handlePageChange (current) {
    const { router, location: { query, pathname } } = this.props
    this.setState({
      current
    })
    router.push({
      pathname,
      query: {
        ...query,
        page: current
      }
    })
  }

  renderHeader () {
    const { tagName } = this.state

    return (
      <div className={styles.header}>
        {tagName}
      </div>
    )
  }

  renderDetail () {

  }

  render () {
    const {
      practiceList,
      recomendsInfo,
      examInfo,
      current,
      totalPage
    } = this.state

    return (
      <div className={styles.container}>
        <div className={styles.main}>
          <div className={styles.body}>
            { this.renderHeader() }
            { this.renderDetail() }
            <PracticeList practiceList={practiceList} className={styles.practiceList} />
          </div>
          <div className={styles.footer}>
            <Pagination total={totalPage} current={current} onChange={this.handlePageChange} />
          </div>
        </div>
        <div className={styles.side}>
          <HotCourse courses={recomendsInfo} examInfo={examInfo} />
        </div>
      </div>
    )
  }
}

export default QuestionListContainer



/** WEBPACK FOOTER **
 ** ./src/pages/QuestionList/index.js
 **/